import { DEFAULT_APPEARANCE } from '@/theme/engine.mjs';
import { rupiah } from "@/lib/format";
import { toast } from "sonner";

export function printClosing(shift, summary, storeName) {
  const s = summary || shift?.summary || {};
  const openedAt = shift?.opened_at ? new Date(shift.opened_at).toLocaleString("id-ID") : "-";
  const closedAt = shift?.closed_at ? new Date(shift.closed_at).toLocaleString("id-ID") : new Date().toLocaleString("id-ID");
  const rows = [
    ["Kasir", shift?.user_name || "-"],
    ["Buka", openedAt],
    ["Tutup", closedAt],
    ["", ""],
    ["Jumlah Transaksi", s.tx_count ?? 0],
    ["Item Terjual", s.items_sold ?? 0],
    ["Total Penjualan", rupiah(s.revenue || 0)],
    ["", ""],
    ["Tunai", rupiah(s.tunai || 0)],
    ["Transfer", rupiah(s.transfer || 0)],
    ["QRIS", rupiah(s.qris || 0)],
    ["Kembalian", rupiah(s.change || 0)],
    ["Piutang (baru)", rupiah(s.piutang || 0)],
    ["Pelunasan Piutang", rupiah(s.pelunasan || 0)],
    ["", ""],
    ["Saldo Awal", rupiah(s.opening_cash ?? shift?.opening_cash ?? 0)],
    ["Kas Seharusnya", rupiah(shift?.cash_expected ?? s.cash_expected ?? 0)],
    ["Kas Dihitung", rupiah(shift?.cash_counted ?? 0)],
    ["Selisih", rupiah(shift?.selisih ?? 0)],
    ...(shift?.variance_reason ? [["Alasan Selisih", shift.variance_reason]] : []),
    ...(shift?.denominations?.length ? [["", ""], ["Rincian Pecahan", ""], ...shift.denominations.map(row => [`${rupiah(row.value)} x ${row.count}`, rupiah(row.total)])] : []),
  ];
  const body = rows.map(([k, v]) =>
    k === "" ? `<tr><td colspan="2"><hr/></td></tr>` : `<tr><td>${k}</td><td style="text-align:right">${v}</td></tr>`
  ).join("");
  const html = `<!doctype html><html><head><title>Closing Shift</title>
    <style>*{font-family:monospace}body{width:280px;margin:0 auto;padding:8px;color:#000}
    h2{text-align:center;margin:4px 0}p{text-align:center;margin:2px 0;font-size:12px}
    table{width:100%;font-size:12px;border-collapse:collapse}td{padding:2px 0}hr{border:none;border-top:1px dashed #000;margin:2px 0}</style>
    </head><body><h2>${storeName || DEFAULT_APPEARANCE.branding.name}</h2><p>LAPORAN TUTUP SHIFT</p><hr/>
    <table>${body}</table><hr/><p>Terima kasih</p></body></html>`;
  const w = window.open("", "_blank", "width=380,height=640");
  if (!w) { toast.error("Popup diblokir. Izinkan popup untuk mencetak."); return; }
  w.document.write(html);
  w.document.close();
  w.focus();
  setTimeout(() => { w.print(); }, 300);
}
